import { render } from "./FeaturesSection.vue?vue&type=template&id=6369af06&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=ts"
export * from "./FeaturesSection.vue?vue&type=script&lang=ts"

import "./FeaturesSection.vue?vue&type=style&index=0&id=6369af06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6369af06"

export default script